


















































import {
  Home,
  Users,
  User,
  BarChart2,
  Settings,
  Bell,
  AlertCircle,
  CheckCircle2,
  Trash2,
  ChevronDown,
  Phone,
  Menu,
  X,
  ClipboardList,
  MessageCircle,
  ChevronRight,
  ShieldCheck,
  GraduationCap,
  ExternalLink,
  Monitor,
  FileText,
  Send,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../app/store";
import { useState,useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import { useNotificationStore } from "../app/notificationStore";
import userIcon from "../assets/user.png";
import { LogOut } from "lucide-react";
import { useLocation } from "react-router-dom";
import ChatDrawer from "../pages/chat/ChatDrawer";
import { getSocket } from "../socket/socket";
import {
  clearNotificationsApi,
  deleteNotificationApi,
  getAllDocumentsApi,
  getChatUnreadApi,
  getMyReportingApi,
  getNotificationsApi,
  getProfileApi,
  getUserDocumentsApi,
} from "../app/api";  
import CreatePayrollInfoModal from "../pages/payroll/components/CreatePayrollInfoModal";
import { isAuthSessionCurrent } from "../utils/authSession";
import { getTodayDateInputValue } from "../utils/dateFormat";
const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

const EDUCATION_REMINDER_DISMISSED_KEY = "uptaskEducationReminderDismissedDate";
const RECENT_CHAT_ACTIVITY_KEY = "uptaskRecentChatActivity";
const getTodayKey = () => getTodayDateInputValue();
const getReportingPopupKey = (userId) => `uptaskReportingSummarySeen:${userId || "guest"}`;
const getMissingDocsPopupKey = (userId) => `uptaskMissingDocsPopupSeen:${userId || "guest"}`;

const getQuickReplyText = (message) => {
  if (message.type === "image") return "sent an image";
  if (message.type === "file") return "sent an attachment";
  return message.chatMessage || message.message || message.text || "sent a message";
};

const getQuickReplyAvatarUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${IMAGE_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

const chunkQuickReplies = (items, size) =>
  Array.from({ length: Math.ceil(items.length / size) }, (_, index) =>
    items.slice(index * size, index * size + size)
  );

const getPersonName = (person = {}) =>
  `${person.first_name || ""} ${person.last_name || ""}`.trim() || "Team member";

const getAvatarUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${IMAGE_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

function QuickReplyPopup({ conversation, index = 0, onClose, onReplySent }) {
  const [reply, setReply] = useState("");
  const messagesRef = useRef(null);
  const messageFingerprint = (conversation?.messages || [])
    .map((message, messageIndex) =>
      message.id ||
      message.messageId ||
      message.createdAt ||
      message.chatMessage ||
      message.message ||
      message.text ||
      messageIndex
    )
    .join("|");

  useEffect(() => {
    const messagePanel = messagesRef.current;
    if (!messagePanel) return;

    requestAnimationFrame(() => {
      messagePanel.scrollTop = messagePanel.scrollHeight;
    });
  }, [messageFingerprint]);

  if (!conversation) return null;

  const { data, messages = [] } = conversation;
  const groupId = data.groupId || data.group_id || null;
  const senderId = data.senderId || data.sender_id || null;
  const senderName =
    data.senderName ||
    `${data.sender_first_name || ""} ${data.sender_last_name || ""}`.trim() ||
    "User";
  const senderProfilePic = data.senderProfilePic || data.sender_profile_pic || "";
  const avatarUrl = getQuickReplyAvatarUrl(senderProfilePic);

  const stop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClose = (e) => {
    stop(e);
    onClose();
  };

  const handleSend = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const trimmedReply = reply.trim();
    if (!trimmedReply) return;

    const socket = getSocket();
    const clientTime = new Date();
    const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
    socket?.emit("send_message", {
      receiverId: groupId ? null : senderId,
      groupId,
      message: trimmedReply,
      clientTime,
    });
    onReplySent?.(conversation.key, {
      ...data,
      id: `quick_reply_${groupId || senderId}_${clientTime.getTime()}`,
      message: trimmedReply,
      text: trimmedReply,
      chatMessage: trimmedReply,
      senderName: "You",
      senderId: currentUser?.id,
      receiverId: groupId ? null : senderId,
      groupId,
      createdAt: clientTime.toISOString(),
    });
    const recentActivity = {
      ...data,
      receiverId: groupId ? null : senderId,
      groupId,
      message: trimmedReply,
      createdAt: clientTime.toISOString(),
    };
    localStorage.setItem(RECENT_CHAT_ACTIVITY_KEY, JSON.stringify(recentActivity));
    window.dispatchEvent(new CustomEvent("uptask:chat-list-message-sent", {
      detail: recentActivity,
    }));
    setReply("");
  };

  return (
    <div
      className="relative w-[240px] rounded-[14px] border border-white/10 bg-[#1b1d29] p-2.5 text-white shadow-[0_14px_36px_rgba(0,0,0,0.42)] sm:w-[270px]"
      style={{ zIndex: 9500 + index }}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="absolute bottom-0 left-0 h-0.5 w-full rounded-b-[14px] bg-gradient-to-r from-indigo-500 via-cyan-400 to-violet-500" />
      <div className="flex items-start gap-2">
        <div className="h-8 w-8 shrink-0 overflow-hidden rounded-full border-2 border-violet-400 bg-gradient-to-tr from-indigo-600 to-purple-600">
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt={senderName}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="grid h-full w-full place-items-center text-xs font-black">
              {senderName.charAt(0).toUpperCase()}
            </div>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-[12px] font-black tracking-tight">{senderName}</p>
          <p className="text-[10px] text-white/55">Quick reply</p>
        </div>
        <button
          type="button"
          onPointerDown={stop}
          onClick={handleClose}
          className="grid h-7 w-7 shrink-0 place-items-center rounded-lg text-white/50 transition hover:bg-white/10 hover:text-white"
          aria-label="Close quick reply"
          title="Close"
        >
          <X size={16} />
        </button>
      </div>

      <div
        ref={messagesRef}
        className="mt-2 max-h-20 space-y-1.5 overflow-y-auto rounded-[12px] border border-white/10 bg-white/[0.06] px-2.5 py-2"
      >
        {messages.length > 0 ? (
          messages.map((message, messageIndex) => (
            <div
              key={`${message.id || message.messageId || message.createdAt || messageIndex}`}
              className={messageIndex > 0 ? "border-t border-white/10 pt-2" : ""}
            >
              <p className="mb-0.5 truncate text-[8px] font-black uppercase tracking-wide text-white/35">
                {message.senderName || senderName}
              </p>
              <p className="break-words text-[11px] leading-4 text-white/85">
                {getQuickReplyText(message)}
              </p>
            </div>
          ))
        ) : (
          <p className="break-words text-[11px] leading-4 text-white/85">sent a message</p>
        )}
      </div>

      <form onSubmit={handleSend} className="mt-2 flex items-center gap-2">
        <input
          value={reply}
          onChange={(e) => setReply(e.target.value)}
          placeholder="Type a quick reply..."
          className="h-8 min-w-0 flex-1 rounded-[11px] border border-white/15 bg-white/[0.06] px-2.5 text-[11px] text-white outline-none placeholder:text-white/45 focus:border-indigo-400/70"
        />
        <button
          type="submit"
          className="grid h-8 w-8 shrink-0 place-items-center rounded-[11px] bg-indigo-600 text-white shadow-lg shadow-indigo-600/20 transition hover:bg-indigo-500 active:scale-95"
          aria-label="Send quick reply"
        >
          <Send size={14} />
        </button>
      </form>
    </div>
  );
}

const isPresent = (value) => String(value ?? "").trim().length > 0;

const hasCompleteEducationDetails = (profile = {}) => {
  return [
    "tenth_year",
    "twelfth_year",
    "graduation_level",
    "graduation_course",
    "graduation_year",
  ].every((field) => isPresent(profile[field]));
};

const normalizeDocumentType = (doc = {}) =>
  String(doc.document_type || doc.document_label || doc.type || doc.file_name || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_");

const hasDocumentMatch = (docs = [], keywords = []) =>
  docs.some((doc) => {
    const type = normalizeDocumentType(doc);
    return keywords.some((keyword) => type.includes(keyword));
  });

const getRequiredDocumentMissingList = (docs = []) => {
  const hasAadhaar = hasDocumentMatch(docs, ["AADHAAR", "ADHAAR", "AADHAR"]);
  const hasPan = hasDocumentMatch(docs, ["PAN"]);
  const hasEducation = hasDocumentMatch(docs, [
    "EDUCATION",
    "EXPERIENCE",
    "DEGREE",
    "GRADUATION",
    "MARKSHEET",
    "CERTIFICATE",
    "TENTH",
    "TWELFTH",
    "10TH",
    "12TH",
  ]);

  return [
    { missing: !hasAadhaar, type: "AADHAAR", label: "Aadhaar" },
    { missing: !hasPan, type: "PAN", label: "PAN" },
    { missing: !hasEducation, type: "EDUCATION", label: "Education document" },
  ].filter((doc) => doc.missing);
};
 
export default function FilloNavbar() {
 
  const location = useLocation();
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);



  const [theme, setTheme] = useState(
    localStorage.getItem("theme") || "dark"
  );
 
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);
 
 
 
  const [profilePic, setProfilePic] = useState(null);
  const removeNotification = useNotificationStore(
    (s) => s.removeNotification
  );
 
 
  const [notifOpen, setNotifOpen] = useState(false);
  const notifRef = useRef(null);
  const navigate = useNavigate();
  const notifications = useNotificationStore((s) => s.notifications);
  const [missingVerificationDocs, setMissingVerificationDocs] = useState([]);
  const [documentsChecked, setDocumentsChecked] = useState(false);
  const [showMissingDocsPopup, setShowMissingDocsPopup] = useState(false);
  const [missingDocsPopupDismissed, setMissingDocsPopupDismissed] = useState(false);
  const [reportingSummary, setReportingSummary] = useState(null);
  const [showReportingPopup, setShowReportingPopup] = useState(false);
  const [profileData, setProfileData] = useState(() => JSON.parse(localStorage.getItem("user")) || {});
  const [educationReminderDismissed, setEducationReminderDismissed] = useState(
    () => localStorage.getItem(EDUCATION_REMINDER_DISMISSED_KEY) === getTodayKey()
  );
 
  const clearUnread = useNotificationStore((s) => s.clearUnread);
  const chatUnreadCount = useNotificationStore((s) => s.chatUnreadCount);
  const setChatUnreadCount = useNotificationStore((s) => s.setChatUnreadCount);
  const setNotifications = useNotificationStore((s) => s.setNotifications);
 
  const [chatOpen, setChatOpen] = useState(false);
  const [chatTarget, setChatTarget] = useState(null);
  const [quickReplies, setQuickReplies] = useState([]);
  const [quickReplyRows, setQuickReplyRows] = useState(3);
  const [isPayrollModalOpen, setIsPayrollModalOpen] = useState(false);


  useEffect(() => {
    const openChatFromData = (parsed) => {
      if (!parsed) return;

      // 🔥 open chat drawer
      setChatOpen(true);
      setChatTarget(parsed);

      // 🔥 store selected chat globally for same-session drawer open
      window.__OPEN_CHAT_TARGET__ = parsed;
      window.__OPEN_CHAT_USER_ID__ = parsed.userId;

      // clear storage
      localStorage.removeItem("openChatFromNotification");
    };

    const chatData = localStorage.getItem("openChatFromNotification");

    if (chatData) {
      openChatFromData(JSON.parse(chatData));
    }

    const handleOpenChatFromNotification = (event) => {
      openChatFromData(event.detail);
    };

    window.addEventListener("uptask:open-chat-from-notification", handleOpenChatFromNotification);
    return () => {
      window.removeEventListener("uptask:open-chat-from-notification", handleOpenChatFromNotification);
    };
  }, []);

  useEffect(() => {
    const updateQuickReplyRows = () => {
      const availableHeight = window.innerHeight - 112;
      const estimatedCardHeight = window.innerWidth < 640 ? 168 : 178;
      setQuickReplyRows(Math.max(1, Math.floor(availableHeight / estimatedCardHeight)));
    };

    updateQuickReplyRows();
    window.addEventListener("resize", updateQuickReplyRows);
    return () => window.removeEventListener("resize", updateQuickReplyRows);
  }, []);

  useEffect(() => {
    const handleQuickReplyMessage = (event) => {
      const data = event.detail;
      if (!data) return;

      const groupId = data.groupId || data.group_id || null;
      const senderId = data.senderId || data.sender_id || null;
      const key = groupId ? `group_${groupId}` : `user_${senderId}`;
      const nextMessage = {
        ...data,
        id:
          data.id ||
          data.messageId ||
          data.message_id ||
          `${senderId || "sender"}_${groupId || data.receiverId || "direct"}_${Date.now()}`,
      };

      setQuickReplies((current) => {
        const existing = current.find((conversation) => conversation.key === key);
        const messages = existing?.messages || [];
        const nextId = String(nextMessage.id || "");
        const deduped = nextId
          ? messages.filter((message) => String(message.id || "") !== nextId)
          : messages;

        const updatedConversation = {
          key,
          data: { ...(existing?.data || {}), ...data },
          messages: [...deduped, nextMessage].slice(-8),
        };

        return [
          updatedConversation,
          ...current.filter((conversation) => conversation.key !== key),
        ].slice(0, 9);
      });
    };

    window.addEventListener("uptask:quick-reply-message", handleQuickReplyMessage);
    return () => {
      window.removeEventListener("uptask:quick-reply-message", handleQuickReplyMessage);
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    const loadNotifications = async () => {
      const res = await getNotificationsApi();
      if (!mounted || !res?.success) return;
      setNotifications(res.data || []);
    };

    loadNotifications();

    return () => {
      mounted = false;
    };
  }, [setNotifications]);

  const handleDeleteNotification = async (notification) => {
    if (notification.persistent || notification.is_persistent) return;

    if (notification.id === "education-details-reminder") {
      localStorage.setItem(EDUCATION_REMINDER_DISMISSED_KEY, getTodayKey());
      setEducationReminderDismissed(true);
      return;
    }

    removeNotification(notification.id);

    if (/^\d+$/.test(String(notification.id))) {
      await deleteNotificationApi(notification.id);
    }
  };

  const handleClearNotifications = async () => {
    if (!educationReminderDismissed && !hasCompleteEducationDetails(profileData)) {
      localStorage.setItem(EDUCATION_REMINDER_DISMISSED_KEY, getTodayKey());
      setEducationReminderDismissed(true);
    }
    useNotificationStore.getState().clearAll();
    await clearNotificationsApi();
  };

  const handleQuickReplySent = (conversationKey, message) => {
    if (!conversationKey || !message) return;

    setQuickReplies((current) =>
      current.map((conversation) => {
        if (conversation.key !== conversationKey) return conversation;

        return {
          ...conversation,
          data: { ...conversation.data, ...message },
          messages: [...(conversation.messages || []), message].slice(-8),
        };
      })
    );
  };

  const { logout } = useAuth();
  const [open, setOpen] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleUptaskTabClick = (event) => {
    if (event) event.preventDefault();

    if (!isAuthSessionCurrent()) {
      logout();
      setMobileOpen(false);
      navigate("/login", { replace: true });
      return;
    }

    setMobileOpen(false);
    navigate("/");
  };

const user = JSON.parse(localStorage.getItem("user"));
const hasProfilePhoto = Boolean(
  profilePic ||
  profileData.profile_pic ||
  profileData.profilePic ||
  user?.profile_pic ||
  user?.profilePic
);
const hasMobileNumber = Boolean(
  String(
    profileData.phone_number ||
    profileData.mobile_number ||
    profileData.mobile ||
    profileData.phone ||
    user?.phone_number ||
    user?.mobile_number ||
    user?.mobile ||
    user?.phone ||
    ""
  ).trim()
);
const missingProfileItems = [
  ...(!hasProfilePhoto
    ? [{ type: "PROFILE_PHOTO", label: "Profile photo", path: "Profile / Edit Profile", route: "/profile" }]
    : []),
  ...(!hasMobileNumber
    ? [{ type: "MOBILE_NUMBER", label: "Mobile number", path: "Profile / Edit Profile", route: "/profile" }]
    : []),
];
const missingProfileRequirements = [
  ...missingProfileItems,
  ...missingVerificationDocs.map((doc) => ({
    ...doc,
    path: "Documents / Upload Documents",
    route: "/upload/documents",
  })),
];
const hasMissingDocuments = missingVerificationDocs.length > 0;
const missingProfilePrimaryRoute = hasMissingDocuments ? "/upload/documents" : "/profile";
const missingProfilePrimaryLabel = hasMissingDocuments ? "Upload documents" : "Complete profile";
const missingDocumentText =
  missingVerificationDocs.length > 0
    ? `Missing ${missingVerificationDocs.map((doc) => doc.label).join(", ")}`
    : "Education and documents complete";

  useEffect(() => {
    let mounted = true;

    const loadRequiredDocuments = async () => {
      if (!user?.id) return;

      const [userDocsRes, allDocsRes] = await Promise.all([
        getUserDocumentsApi(user.id),
        getAllDocumentsApi(),
      ]);
      if (!mounted) return;

      if (!userDocsRes?.success && !allDocsRes?.success) {
        setDocumentsChecked(false);
        return;
      }
      setDocumentsChecked(true);

      const allUserDocs = (allDocsRes?.data || []).filter(
        (doc) => String(doc.user_id || doc.employee_id || "") === String(user.id)
      );
      const mergedDocs = [
        ...(userDocsRes?.data || []),
        ...allUserDocs,
      ];
      const missing = getRequiredDocumentMissingList(mergedDocs);

      setMissingVerificationDocs(missing);
    };

    loadRequiredDocuments();

    window.addEventListener("focus", loadRequiredDocuments);
    window.addEventListener("storage", loadRequiredDocuments);

    return () => {
      mounted = false;
      window.removeEventListener("focus", loadRequiredDocuments);
      window.removeEventListener("storage", loadRequiredDocuments);
    };
  }, [user?.id]);

  useEffect(() => {
    const dismissedToday =
      localStorage.getItem(getMissingDocsPopupKey(user?.id)) === getTodayKey();

    if (dismissedToday && !missingDocsPopupDismissed) {
      setMissingDocsPopupDismissed(true);
    }

    if (
      !documentsChecked ||
      missingProfileRequirements.length === 0 ||
      missingDocsPopupDismissed ||
      dismissedToday
    ) {
      setShowMissingDocsPopup(false);
      return;
    }

    setShowMissingDocsPopup(true);
  }, [documentsChecked, missingDocsPopupDismissed, missingProfileRequirements.length, user?.id]);

  useEffect(() => {
    setMissingDocsPopupDismissed(
      localStorage.getItem(getMissingDocsPopupKey(user?.id)) === getTodayKey()
    );
  }, [user?.id]);

  useEffect(() => {
    let mounted = true;

    const loadReportingSummary = async () => {
      if (!user?.id) return;

      const res = await getMyReportingApi();
      if (!mounted || !res?.success) return;

      const data = res.data || {};
      const hasReporting =
        (data.teamMembers || []).length > 0 ||
        (data.reportingManagers || []).length > 0 ||
        (data.directors || []).length > 0;

      setReportingSummary(data);

      if (hasReporting && sessionStorage.getItem(getReportingPopupKey(user.id)) !== "1") {
        setShowReportingPopup(true);
      }
    };

    loadReportingSummary();

    return () => {
      mounted = false;
    };
  }, [user?.id]);

  const closeMissingDocsPopup = () => {
    localStorage.setItem(getMissingDocsPopupKey(user?.id), getTodayKey());
    setMissingDocsPopupDismissed(true);
    setShowMissingDocsPopup(false);
  };

  const closeReportingPopup = () => {
    sessionStorage.setItem(getReportingPopupKey(user?.id), "1");
    setShowReportingPopup(false);
  };

  const goToMissingProfileRoute = () => {
    closeMissingDocsPopup();
    navigate(missingProfilePrimaryRoute);
  };

const hasExperience = Number(user?.experience) >= 2;
const roleId = Number(user?.role_id);
const canAccessAdminMenu = [1, 2, 3].includes(roleId);
const isHR = canAccessAdminMenu;
const canApproveProfileChanges = canAccessAdminMenu;

const normalizeNotificationType = (type = "") =>
  String(type).replace(/[_-]+/g, " ").trim().toUpperCase();

const parseNotificationMetadata = (metadata) => {
  if (!metadata) return {};
  if (typeof metadata === "object") return metadata;

  try {
    return JSON.parse(metadata);
  } catch {
    return {};
  }
};

const isOwnLeaveNotification = (notification) => {
  const metadata = parseNotificationMetadata(notification.metadata);
  const applicantId =
    metadata.user_id ||
    metadata.employee_id ||
    metadata.applicant_id ||
    notification.userdata?.id ||
    notification.userdata?.user_id ||
    notification.userdata?.employee_id;

  if (applicantId && String(applicantId) === String(user?.id)) {
    return true;
  }

  const ownName = `${user?.first_name || ""} ${user?.last_name || ""}`
    .trim()
    .toLowerCase();

  return ownName && String(notification.message || "").toLowerCase().includes(ownName);
};

const canShowNotification = (notification) => {
  if (isHR) return true;

  const type = normalizeNotificationType(notification.type);

  if (type === "CHAT") return true;
  if (type.includes("TASK")) return true;
  if (type.includes("PROFILE CHANGE")) return true;
  if (type.includes("PROFILE DOCUMENT")) return true;
  if (type.includes("PROJECT")) return true;
  if (type.includes("QUOTE")) return true;
  if (type.includes("BIRTHDAY")) return true;
  if (type.includes("ANNIVERSARY")) return true;
  if (type.includes("NEW JOINER") || type.includes("JOINER")) return true;
  if (type === "LEAVE" || type.includes("LEAVE")) return isOwnLeaveNotification(notification);

  return false;
};

const verificationNotification =
  missingVerificationDocs.length > 0
    ? {
        id: "required-documents-verification",
        type: "DOCUMENT VERIFICATION",
        message: `Upload ${missingVerificationDocs
          .map((doc) => doc.label)
          .join(" and ")} for verification.`,
        created_at: new Date().toISOString(),
        is_read: false,
        persistent: true,
        redirectTo: "/upload/documents",
      }
    : null;

const educationComplete = hasCompleteEducationDetails(profileData);
const hasEducationDocument = !missingVerificationDocs.some((doc) => doc.type === "EDUCATION");
const educationVerified = educationComplete || hasEducationDocument;
const profileVerified = documentsChecked && educationVerified && missingVerificationDocs.length === 0;
const missingVerificationText = !educationVerified
  ? "Pending education details"
  : missingDocumentText;
const reportingTeamMembers = reportingSummary?.teamMembers || [];
const reportingManagers = reportingSummary?.reportingManagers || [];
const reportingDirectors = reportingSummary?.directors || [];
const canCreateUserTasks = Boolean(user?.id || user?.user_id);
const educationNotification =
  !educationVerified && !educationReminderDismissed
    ? {
        id: "education-details-reminder",
        type: "EDUCATION REMINDER",
        message: "Complete your education details on Uptask for profile verification.",
        created_at: new Date().toISOString(),
        is_read: false,
        redirectTo: "/profile",
      }
    : null;

const visibleNotifications = [
  ...(verificationNotification ? [verificationNotification] : []),
  ...(educationNotification ? [educationNotification] : []),
  ...notifications.filter(canShowNotification),
];
const visibleUnreadCount = visibleNotifications.filter((notification) => !notification.is_read).length;

const canSeeAllProjects =
  Number(user?.experience) >= 2 || isHR;
 
 
 
const username = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
  const menu = [
    { label: "Dashboard", icon: Home, path: "/" },
 
 
    ...(isHR
      ? [
          {
            label: "Employees",
            icon: Users,
            children: [
              { label: "Create User", path: "/employees/create" },
              { label: "Employees", path: "/employees" },
              { label: "Departments", path: "/departments" },
              { label: "Reporting Tool", path: "/employees/reporting" },
              { label: "Approve Changes", path: "/employees/profile-change-requests" },
              { label: "Approve Documents", path: "/employees/profile-document-requests" },
              { label: "Ex Employees", path: "/employees/ex" },
            ],
          },
        ]
      : []),
    ...(!isHR && canApproveProfileChanges
      ? [
          {
            label: "Approve Changes",
            icon: ShieldCheck,
            path: "/employees/profile-change-requests",
          },
          {
            label: "Approve Documents",
            icon: FileText,
            path: "/employees/profile-document-requests",
          },
        ]
      : []),
 
    {
      label: "Attendance",
      icon: BarChart2,
      children: [
 
       
        { label: "My Attendance", path: "/attendance/me" },
     
 
         // only HR
    ...(isHR
      ? [
          { label: "All Attendance", path: "/attendance/all" },
          { label: "Monthly", path: "/attendance/monthly" },
        ]
      : []),
      ],
    },
 
    /* ================= TASKS ================= */
    {
      label: "Tasks",
      icon: ClipboardList,
      children: [
        ...(canCreateUserTasks
          ? [
              {
                label: "Create Task",
                onClick: () => navigate("/tasks/my", { state: { openCreate: Date.now() } }),
              },
            ]
          : []),
        { label: "All Tasks", path: "/tasks/all" },
        { label: "Team Tasks", path: "/tasks/team" },
        { label: "Assigned Tasks", path: "/tasks/assigned" },
        { label: "Monthly Tasks", path: "/tasks/monthly" },
      ],
    },
 
    // ====================projects=====================


    {
      label: "Projects",
      icon: ClipboardList,
      children: [
        { label: "Create Project", path: "/projects/create" },
    
        ...(canSeeAllProjects
          ? [{ label: "All Projects", path: "/projects/all" }]
          : []),
    
        { label: "My Projects", path: "/projects/my" },
      ],
    },



 
    {
      label: "Documents",
      icon: ClipboardList,
      children: [
        { label: "Upload Documents", path: "upload/documents" },
     
 
        ...(isHR
          ? [
            { label: "All Documents", path: "/documents/all" },
            ]
          : []),
      ],
    },


    // {
    //   label: "Gallery",
    //   icon: ClipboardList,
    //   children: [
    //     { label: "View Gallery", path: "/gallery" },
     
 
        
    //   ],
    // },
 


    {
      label: "Gallery",
      icon: ClipboardList,
      path: "/gallery",
    },

    // {
    //   label: "Screenshots",
    //   icon: ClipboardList,
    //   path: "/screenshots",
    // },


...(isHR
  ? [
      {
        label: "Screenshots",
        icon: ClipboardList,
        path: "/screenshots",
      },
    ]
  : []),

 

    {
      label: "Grievance",
      icon: MessageCircle,
      path: "/grievance",
    },

    ...(canApproveProfileChanges
      ? [
          {
            label: "Quote Requests",
            icon: MessageCircle,
            path: "/quotes/requests",
          },
        ]
      : []),
    // {
    //   label: "Our Policy",
    //   icon: ShieldCheck,
    //   path: "/visiontrek/policy",
    // },



    {
      label: "Policies",
      icon: ShieldCheck,
      children: [
        // { label: "Leave Policy", path: "/leaves/policy" },
        { 
          label: "Leave Policy",
          path: "/Leave policy (2026) 1.pdf",
          external: true,
          icon: ExternalLink
        },
        { 
          label: "Increment Policy",
          path: "/Increment.pdf",
          external: true,
          icon: ExternalLink
        },
      ],
    },

 
    ...(isHR
      ? [
        {
          label: "Expenses",
          icon: Settings,
          children: [
            { label: "Add Expense", path: "/expenses/add" },
            { label: "Expense List", path: "/expenses" },
            { label: "Wallet", path: "/expenses/wallet" },
            { label: "Categories", path: "/expenses/categories" },
          ],
        },
   
        ]
      : []),
 
    {
      label: "Leaves",
      icon: Settings,
      children: [
        { label: "Apply Leave", path: "/leaves/apply" },
        { label: "My Leaves", path: "/leaves/me" },
       
 
        ...(isHR
          ? [
            { label: "Pending", path: "/leaves/pending" },
            { label: "Leave Report", path: "/leaves/report" },
            ]
          : []),
 
        { label: "Leave Policy", path: "/leaves/policy" },
        { label: "Holidays", path: "/leaves/holidays" },
      ],
    },
 
 
    ...(isHR
      ? [
        {
          label: "Inventory",
          icon: Settings,
          children: [
            // { label: "Inventory Type", path: "/inventory" },
            { label: "All Items", path: "/inventory/all" },
            { label: "Assigned Items", path: "/inventory/assign" },
            { label: "Add Item Type", path: "/inventory/add" },
           
          ],
        },
   
        ]
      : []),
    ...(isHR
      ? [
        {
          label: "Payroll",
          icon: ClipboardList,
          children: [
            { label: "Payroll Overview", path: "/payroll" },
            { label: "Monthly Records", path: "/payroll/records" },
            { label: "Salary Details", path: "/payroll/salaries" },
            { label: "Increment Section", path: "/payroll/increment" },
            { label: "Create User Info", onClick: () => setIsPayrollModalOpen(true) },
            { label: "Payslips", path: "/payroll/payslips" },
          ],
        },
      ]
      : []),

    // Tracker download - visible to all users
    {
      label: "Tracker",
      icon: Monitor,
      children: [
        {
          label: "Mac Tracker (.dmg)",
          path: "https://uptask.visiontrek.io/downloads/Uptask%20Tracker.dmg",
          external: true,
        },
        {
          label: "Windows Tracker (.exe)",
          path: "https://uptask.visiontrek.io/downloads/Uptask%20Tracker%20Setup.exe",
          external: true,
        },
      ],
    },
    ];
 


  // 👇 Pick what you want visible

  const visibleLabels = ["Dashboard", "Attendance", "Tasks", "Projects", "Leaves", "Payroll"];

  const desktopVisibleMenu = menu.filter((item) =>
    visibleLabels.includes(item.label)
  );

  const desktopMoreMenu = menu.filter(
    (item) => !visibleLabels.includes(item.label)
  );


 
  const desktopMenu = [
    ...desktopVisibleMenu,
    ...(desktopMoreMenu.length > 0
      ? [
      

          {
            label: "More",
            isMore: true,
            children: desktopMoreMenu,
          }
        ]
      : []),
  ];
 
 
 
  const scrollToContent = () => {
    setMobileOpen(false);
    setTimeout(() => {
      const el = document.getElementById("page-content");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);
  };
 
 
 
  useEffect(() => {
    function handleClickOutside(e) {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
    }
 
    if (notifOpen) {
      document.addEventListener("click", handleClickOutside);
    }
 
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [notifOpen]);
 
 
 
 
 
  useEffect(() => {
    const loadProfile = async () => {
      const res = await getProfileApi();
      if (res?.success) {
        setProfilePic(res.data.profile_pic);
        setProfileData((current) => ({ ...current, ...res.data }));
      }
    };
   
    const loadUnreadChats = async () => {
      try {
        const res = await getChatUnreadApi();
        if (res?.success) setChatUnreadCount(res.count);
      } catch(e){}
    };
 
    loadProfile();
    loadUnreadChats();
  }, [setChatUnreadCount]);
 




  useEffect(() => {
    function handleClickOutside(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    }
  
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);





  const formatNotifTime = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric", // optional but better
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getRelativeNotifTime = (date) => {
    if (!date) return "";
    const now = new Date();
    const d = new Date(date);
    const diffInSeconds = Math.floor((now - d) / 1000);

    if (diffInSeconds < 60) return "Now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    
    if (now.toDateString() === d.toDateString()) return "Today";
    
    const diffInDays = Math.floor(diffInSeconds / 86400);
    if (diffInDays === 1) return "1 day ago";
    return `${diffInDays} days ago`;
  };





 
  return (
    <>
      {/* ================= TOP NAVBAR ================= */}
      <div
        className="
        h-16 px-4 sm:px-6 flex items-center justify-between
        bg-[#291857]
        shadow-lg shadow-black/40
        backdrop-blur-xl
        border-b border-white/10
        text-white
        relative z-50
      "
      >
        {/* LEFT */}
        <div className="flex items-center gap-4">
          <button className="lg:hidden" onClick={() => setMobileOpen(true)}>
            <Menu size={22} />
          </button>
 
       
        </div>
 
        {/* CENTER (DESKTOP MENU) */}
        <div className="hidden lg:flex gap-6 text-[13px] relative font-bold">
          {desktopMenu.map((item, i) => {
            const Icon = item.icon;
            const isActive = item.path
            ? location.pathname === item.path
            : item.children?.some((sub) =>
                location.pathname.startsWith(sub.path)
              );
            return (
              <div
                key={i}
                className="relative"
                onMouseEnter={() => setOpen(i)}
                onMouseLeave={() => setOpen(null)}
              >
          

{/* <div className="flex items-center gap-0.5 cursor-pointer hover:text-purple-200 py-1"> */}




<div
  className={`
    flex items-center gap-1 cursor-pointer py-1 px-2 rounded-md transition
    ${isActive ? "bg-white/20 text-white" : "hover:bg-white/10"}
  `}
>
  {/* {item.path ? (
    <Link
      to={item.path}
      onClick={item.path === "/" ? handleUptaskTabClick : undefined}
      className="flex items-center gap-2"
    >
      {item.icon && <Icon size={14} />}
      {item.label}
    </Link>
  ) : ( */}

{item.path ? (
  item.external ? (
    <a
      href={item.path}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2"
    >
      {item.icon && <Icon size={14} />}
      {item.label}
    </a>
  ) : (
    <Link to={item.path} className="flex items-center gap-2">
      {item.icon && <Icon size={14} />}
      {item.label}
    </Link>
  )
) : (
    <>
      {item.icon && <Icon size={14} />}
      {item.label}
      <ChevronDown size={14} />
    </>
  )}
</div>
 
                {item.children && open === i && (
                  <div
                    className={`
                    absolute left-0 top-[100%] z-50
                    bg-[#3a2a72]/95
                    backdrop-blur-sm
                    border border-white/10
                    rounded-xl shadow-lg
                    py-2 whitespace-nowrap
                    `}
                    style={{ minWidth: item.isMore ? '180px' : '144px' }}
                  >
                    <div className="absolute -top-2 left-0 w-full h-2" />
                    {item.isMore ? (
                        item.children.map((moreItem, idx) => {
                            const MoreIcon = moreItem.icon;
                            const content = (
                                <div className="flex items-center gap-2 w-full">
                                    {MoreIcon && <MoreIcon size={14} />}
                                    {moreItem.label}
                                    {moreItem.children && <ChevronRight size={14} className="ml-auto" />}
                                </div>
                            );
                            return (
                                <div
                                    key={idx}
                                    className="relative group px-4 py-2 hover:bg-[#4b3a8a] cursor-pointer"
                                >
                                    {moreItem.path ? (
                                        moreItem.external ? (
                                            <a 
                                                href={moreItem.path} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="block w-full"
                                            >
                                                {content}
                                            </a>
                                        ) : (
                                            <Link to={moreItem.path} className="block w-full">{content}</Link>
                                        )
                                    ) : (
                                        <div className="block w-full">{content}</div>
                                    )}
 
                                    {moreItem.children && (
                                        <div className="absolute left-[99%] top-0 hidden group-hover:block bg-[#3a2a72]/95 backdrop-blur-md border border-white/10 rounded-xl shadow-lg py-2 min-w-[144px]">
                                            <div className="absolute -left-2 top-0 w-2 h-full" />
                                            {moreItem.children.map((sub, j) => {
                                                const SubIcon = sub.icon;
                                                const subContent = (
                                                    <div className="flex items-center gap-2">
                                                        {SubIcon && <SubIcon size={14} />}
                                                        {sub.label}
                                                    </div>
                                                );
                                                return sub.external ? (
                                                    <a
                                                        key={j}
                                                        href={sub.path}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="block px-4 py-2 hover:bg-[#4b3a8a]"
                                                    >
                                                        {subContent}
                                                    </a>
                                                ) : (
                                                    <Link
                                                        key={j}
                                                        to={sub.path}
                                                        className="block px-4 py-2 hover:bg-[#4b3a8a]"
                                                    >
                                                        {subContent}
                                                    </Link>
                                                )
                                            })}


</div>
                                    )}
                                </div>
                            );
                        })
                    ) : (
//                         item.children.map((sub, j) => (
                          
//                             <Link
//   key={j}
//   to={sub.path}
//   className={`
//     block px-4 py-2
//     ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
//   `}
// >
//                                 {sub.label}
//                             </Link>
//                         ))





item.children.map((sub, j) => {
  const SubIcon = sub.icon;
  const subContent = (
    <div className="flex items-center gap-2">
      {SubIcon && <SubIcon size={14} />}
      {sub.label}
    </div>
  );
  return (
    <div key={j}>
      {sub.onClick ? (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpen(null);
            sub.onClick();
          }}
          className="w-full text-left block px-4 py-2 hover:bg-[#4b3a8a] transition"
        >
          {subContent}
        </button>
      ) : sub.external ? (
        <a
          href={sub.path}
          target="_blank"
          rel="noopener noreferrer"
          className="block px-4 py-2 hover:bg-[#4b3a8a]"
        >
          {subContent}
        </a>
      ) : (
        <Link
          to={sub.path}
          className={`
            block px-4 py-2
            ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
          `}
        >
          {subContent}
        </Link>
      )}
    </div>
  )
})
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
 
        {/* RIGHT */}
        <div className="flex items-center gap-3 py-1 pl-2 pr-4 text-sm">
<div className="relative flex items-center gap-3">
  <button
      onClick={() => {
        setChatTarget(null);
        setChatOpen(true);
      }}
      className="relative grid h-10 w-10 place-items-center rounded-full border border-white/15 bg-white/[0.08] text-white shadow-[0_8px_24px_rgba(0,0,0,0.22)] transition hover:-translate-y-0.5 hover:bg-white/[0.14] hover:shadow-[0_12px_28px_rgba(0,0,0,0.28)]"
      aria-label="Open chat"
    >
      <MessageCircle size={24} strokeWidth={2.25} />
      {chatUnreadCount > 0 && (
        <span className="
        absolute -top-1.5 -right-1.5
        min-w-[20px] h-5 px-1
        rounded-full border-2 border-[#2d1763]
        bg-gradient-to-br from-red-400 to-rose-600 text-white
        text-[10px] font-black leading-none
        flex items-center justify-center
        shadow-[0_8px_18px_rgba(244,63,94,0.42)]
         ">
          {chatUnreadCount > 99 ? "99+" : chatUnreadCount}
        </span>
      )}
  </button>

  <button
      onClick={(e) => {
      e.stopPropagation();        // 🔥 THIS LINE FIXES IT
      setNotifOpen((o) => !o);
      clearUnread();
    }}
    className="relative grid h-10 w-10 place-items-center rounded-full border border-white/15 bg-white/[0.08] text-white shadow-[0_8px_24px_rgba(0,0,0,0.22)] transition hover:-translate-y-0.5 hover:bg-white/[0.14] hover:shadow-[0_12px_28px_rgba(0,0,0,0.28)]"
    aria-label="Open notifications"
  >
 
  <Bell
  size={24}
  strokeWidth={2.25}
  className={visibleUnreadCount > 0 ? "animate-bell" : ""}
/>
 
    {visibleUnreadCount > 0 && (
      <span
        className="
          absolute -top-1.5 -right-1.5
          min-w-[20px] h-5 px-1
          rounded-full border-2 border-[#2d1763]
          bg-gradient-to-br from-red-400 to-rose-600 text-white
          text-[10px] font-black leading-none
          flex items-center justify-center
          shadow-[0_8px_18px_rgba(244,63,94,0.42)]
        "
      >
        {visibleUnreadCount > 99 ? "99+" : visibleUnreadCount}
      </span>
    )}
  </button>
 
 
</div>


 <div
  className="relative h-11 w-11"
  ref={profileRef}
  title={profileVerified ? "Verified profile" : "Profile not verified"}
>
  <button
    onClick={(e) => {
      e.stopPropagation();
      setProfileOpen((prev) => !prev);
    }}
    className="grid h-11 w-11 place-items-center overflow-hidden rounded-full border-2 border-white/25 bg-white/15 shadow-[0_10px_26px_rgba(0,0,0,0.28)] transition hover:-translate-y-0.5 hover:border-white/45"
    aria-label="Open profile menu"
  >
    {profilePic ? (
      <img
        src={`${IMAGE_BASE_URL}${profilePic}`}
        className="h-full w-full object-cover"
        alt="Profile"
        />
    ) : (
      <User size={22} />
    )}
  </button>
  <span
    className={`
      absolute -right-1 -bottom-1 grid h-5 w-5 place-items-center rounded-full
      border-2 border-[#2d1763] shadow-[0_5px_14px_rgba(0,0,0,0.35)]
      ${profileVerified ? "bg-emerald-400 text-[#062a1e]" : "bg-amber-400 text-[#341a00]"}
    `}
    aria-label={profileVerified ? "Verified profile" : "Profile not verified"}
  >
    {profileVerified ? <CheckCircle2 size={14} strokeWidth={2.5} /> : <AlertCircle size={14} strokeWidth={2.5} />}
  </span>

  {profileOpen && (
      
<div className="absolute right-0 mt-2 w-56 overflow-hidden rounded-xl border border-white/10 bg-[#281c55]/95 text-white shadow-[0_18px_50px_rgba(0,0,0,0.35)] backdrop-blur-xl z-50">

<div className="border-b border-white/10 px-4 py-3">
  <div className="flex items-center gap-2 text-sm font-semibold">
    <span
      className={`grid h-7 w-7 place-items-center rounded-full ${
        profileVerified ? "bg-emerald-400/18 text-emerald-200" : "bg-amber-400/18 text-amber-200"
      }`}
    >
      {profileVerified ? <CheckCircle2 size={16} /> : <AlertCircle size={16} />}
    </span>
    {profileVerified ? "Verified" : "Not verified"}
  </div>
  <p className="mt-1 text-[11px] leading-snug text-white/55">
    {profileVerified ? "Education and documents complete" : missingVerificationText}
  </p>
</div>

<Link
  to="/profile"
  onClick={() => setProfileOpen(false)}
  className="flex items-center gap-2 px-4 py-2 hover:bg-[#4b3a8a] text-white"
>
  <User size={16} className="text-white" />
  Profile
</Link>

<button
  onClick={() => {
    setProfileOpen(false);
    logout();
  }}
  className="w-full flex items-center gap-2 px-4 py-2 text-left hover:bg-red-500/30 text-white"
>
  <LogOut size={16} className="text-white" />
  Logout
</button>

</div>


  )}
</div>

        </div>
      </div>
 
      {/* ================= MOBILE SIDEBAR ================= */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileOpen(false)}
          />
 
          <div
            className="
            absolute left-0 top-0 h-full w-72
            bg-[#291857]
            shadow-2xl shadow-black/50
            p-5
            flex flex-col gap-4
            text-white
            overflow-y-auto
          "
          >
            <div className="flex justify-between items-center mb-4">
              <button
                type="button"
                onClick={handleUptaskTabClick}
                className="text-lg font-semibold"
              >
                UPTASK
              </button>
              <button onClick={() => setMobileOpen(false)}>
                <X size={22} />
              </button>
            </div>
 
            {menu.map((item, i) => {
              const Icon = item.icon;
 
              return (
                <div key={i}>
                  {item.path ? (
                    item.external ? (
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setMobileOpen(false)}
                        className="flex items-center gap-3 py-2"
                      >
                        <Icon size={18} />
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.path}
                        onClick={item.path === "/" ? handleUptaskTabClick : () => setMobileOpen(false)}
                        className="flex items-center gap-3 py-2"
                      >
                        <Icon size={18} />
                        {item.label}
                      </Link>
                    )
                  ) : (
                    <>
                      <div className="flex items-center gap-3 py-2 opacity-80">
                        <Icon size={18} />
                        {item.label}
                      </div>
 
                      <div className="ml-7 flex flex-col text-sm opacity-70">
                        {item.children.map((sub, j) => {
                          const SubIcon = sub.icon;
                          const subContent = (
                            <div className="flex items-center gap-3">
                              {SubIcon && <SubIcon size={18} />}
                              {sub.label}
                            </div>
                          );
                          if (sub.onClick) {
                            return (
                              <button
                                key={j}
                                onClick={() => {
                                  setMobileOpen(false);
                                  sub.onClick();
                                }}
                                className="py-1 text-left w-full"
                              >
                                {subContent}
                              </button>
                            );
                          }

                          return sub.external ? (
                            <a
                              key={j}
                              href={sub.path}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => setMobileOpen(false)}
                              className="py-1"
                            >
                              {subContent}
                            </a>
                          ) : (
                            <Link
                              key={j}
                              to={sub.path}
                              onClick={scrollToContent}
                              className="py-1"
                            >
                              {subContent}
                            </Link>
                          )
                        })}
                      </div>
                    </>
                  )}
                </div>
              );
            })}
 

 
            <div className="mt-auto pt-4 border-t border-white/10">
 
 
 
              <button
                onClick={logout}
                className="w-full bg-red-500 py-2 rounded"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
 
 
 
 
 
 
 
 
 
 
 
      {/* ================= NOTIFICATION DRAWER ================= */}
{/* ================= NOTIFICATION DRAWER ================= */}
 
<div
  className={`
  fixed top-0 right-0 h-full w-[400px] max-w-[95vw]
  bg-[#2A1D55]/95
  supports-[backdrop-filter]:bg-white/10
  backdrop-blur-xl
  border-l border-white/20
  shadow-[0_20px_60px_rgba(0,0,0,0.4)]
  z-[60]
  transform transition-all duration-500 ease-outout
    ${notifOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}
  `}
>
 
  {/* HEADER */}
  <div className="flex justify-between items-center px-5 py-4 border-b border-white/20 backdrop-blur-md bg-[#2A1D55]">
 
    <span className="text-lg font-semibold text-white tracking-wide ">
      Notifications
    </span>
 
    <button
      onClick={() => setNotifOpen(false)}
      className="p-1 rounded-lg text-white/70 hover:text-red-400 hover:bg-white/10 transition"
    >
      <X size={20} />
    </button>
 
  </div>
 
 
  {/* CLEAR ALL */}
  {visibleNotifications.some((notification) => !(notification.persistent || notification.is_persistent)) && (
    <div className="flex justify-end px-5 mt-2 ">
      <button
        onClick={handleClearNotifications}
        className="
          text-xs font-semibold
          text-red-500 hover:text-red-400
          transition
        "
      >
        Clear All
      </button>
    </div>
  )}
 
 
  {/* BODY */}
  {visibleNotifications.length === 0 ? (
    <div className="flex items-center justify-center h-[70%] text-white/70 text-sm">
      No notifications
    </div>
  ) : (
    <ul className="overflow-y-auto h-[calc(100%-120px)] p-4 space-y-3">
 
      {visibleNotifications.map((n) => (

      

//         <li
//         key={n.id}
//         className="
//           relative flex gap-3 p-3
//           bg-white/10 backdrop-blur-md
//           border border-white/10
//           rounded-xl
//           hover:bg-white/20
//           transition-all duration-200
//           shadow-md
//           group
//         "
// >

        <li
        key={n.id}
        className={`
    relative flex gap-3 p-3
        border rounded-xl hover:bg-[#2a2a40]
       transition-all duration-200 shadow-md group backdrop-blur-sm
       ${n.persistent || n.is_persistent
          ? "bg-cyan-400/12 border-cyan-200/25 ring-1 ring-cyan-200/15"
          : "bg-[#1e1e2f]/80 border-white/10"}
        `}
>

        {/* DELETE BUTTON */}
{!(n.persistent || n.is_persistent) && (
<button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteNotification(n);
          }}
          className="
            absolute top-2 right-2
            grid h-7 w-7 place-items-center rounded-lg
            bg-white/8 text-white/55
            opacity-0 group-hover:opacity-100
            transition
            hover:bg-red-500/20 hover:text-red-300
          "
          title="Delete notification"
>
<Trash2 size={14} />
</button>
)}

        {/* AVATAR */}
<div className="w-9 h-9 rounded-full overflow-hidden bg-white/20 border border-white/20 shrink-0">

{n.persistent || n.is_persistent ? (
  <div className="grid h-full w-full place-items-center bg-cyan-300/18 text-cyan-100">
    <ShieldCheck size={18} />
  </div>
) : normalizeNotificationType(n.type) === "EDUCATION REMINDER" ? (
  <div className="grid h-full w-full place-items-center bg-violet-400/20 text-violet-100">
    <GraduationCap size={18} />
  </div>
) : (


  <img
    src={
      n.sender_profile_pic
        ? `${IMAGE_BASE_URL}${n.sender_profile_pic}`
        : n.userdata?.profile_pic
        ? `${IMAGE_BASE_URL}${n.userdata.profile_pic}`
        : userIcon
    }
    className="w-9 h-9 object-cover"
    alt="User"
    onError={(e) => (e.target.src = userIcon)}
  />
)}
</div>

{/* RELATIVE TIME IN TOP RIGHT */}
<div className="absolute top-1 right-3 text-[8px] font-bold text-white/50 uppercase tracking-wider group-hover:opacity-0 transition-opacity">
  {getRelativeNotifTime(n.created_at)}
</div>
<div
          className="flex-1 cursor-pointer"
       




          onClick={() => {
            if (!(n.persistent || n.is_persistent)) {
              handleDeleteNotification(n);
            }
            setNotifOpen(false);
          
            const typeKey = normalizeNotificationType(n.type);
            const metadata = parseNotificationMetadata(n.metadata);
            const userdata = parseNotificationMetadata(n.userdata);
            const redirectTo = n.redirectTo || metadata.redirectTo || userdata.redirectTo;
            const projectId = metadata.project_id || metadata.projectId || userdata.project_id || userdata.projectId;
            const taskId =
              metadata.ref_id ||
              metadata.task_id ||
              metadata.taskId ||
              userdata.ref_id ||
              userdata.task_id ||
              userdata.taskId ||
              n.ref_id ||
              n.task_id ||
              n.taskId;
          
            if (typeKey === "DOCUMENT VERIFICATION") {
              navigate(redirectTo || "/upload/documents");
            } else if (typeKey === "EDUCATION REMINDER") {
              navigate("/profile", { state: { openProfileUpdate: true } });
            } else if (typeKey === "LEAVE") {
              navigate("/leaves/pending");
            } else if (typeKey === "PROFILE CHANGE REQUEST") {
              navigate(redirectTo || "/employees/profile-change-requests", {
                state: { requestId: metadata.request_id || userdata.request_id, employeeId: metadata.employee_id || userdata.employee_id },
              });
            } else if (
              typeKey === "PROFILE CHANGE APPROVED" ||
              typeKey === "PROFILE CHANGE REJECTED"
            ) {
              navigate("/profile");
            } else if (typeKey === "PROFILE DOCUMENT REQUEST") {
              navigate(redirectTo || "/employees/profile-document-requests", {
                state: { employeeId: metadata.employee_id || userdata.employee_id },
              });
            } else if (
              typeKey === "PROFILE DOCUMENT APPROVED" ||
              typeKey === "PROFILE DOCUMENT REJECTED"
            ) {
              navigate("/profile");
          
            } else if (typeKey === "CHAT") {
              setChatOpen(true);
            } else if (typeKey === "PROJECT CREATED" || typeKey === "PROJECT SUBMITTED") {
              navigate(redirectTo || "/projects/all", {
                state: { projectId, highlightProjectId: projectId },
              });
            } else if (typeKey === "QUOTE REQUEST") {
              navigate(redirectTo || "/quotes/requests", {
                state: { quoteId: metadata.quote_id || metadata.quoteId || userdata.quote_id || userdata.quoteId },
              });

            } else if (typeKey === "LATE PUNCH IN") {
                navigate("/attendance/all");

              } else if (typeKey === "EXTRA BREAK") {
                navigate("/attendance/all");
              } else if (typeKey === "EARLY PUNCH OUT") {
                navigate("/attendance/all");


              } else if (
                typeKey === "TASK ASSIGNED" ||
                typeKey === "TASK COMMENT" ||
                typeKey === "TASK UPDATED" ||
                typeKey === "TASK DUE TODAY"
              ) {
                navigate("/", { state: { taskId } });
                
              } else if (typeKey === "GRIEVANCE_UPDATE") {
                navigate("/grievance");



              } else if (typeKey === "DUE DATE CHANGED") {
                navigate("/tasks/all");






          
            } else if (
              typeKey.includes("POST") || 
              typeKey.includes("FEED")
            ) {
              navigate("/", { state: { tab: "posts" } });
          
            } else {
              // ✅ MAIN FIX (your requirement)
              navigate(redirectTo || "/");
            }
          }}
>


<div className="text-sm font-medium text-white leading-snug">
              {n.message}
            </div>
 
            <div className="flex items-center gap-2 mt-1">
 
              <span className={`
                text-[10px]
                px-2 py-[2px]
                rounded-sm shadow-lg
                ${n.persistent || n.is_persistent
                  ? "bg-cyan-400/20 text-cyan-100"
                  : "bg-purple-500/30 text-purple-200"}
                font-semibold
              `}>
                {n.type.toUpperCase()}
              </span>
              {(n.persistent || n.is_persistent) && (
                <span className="rounded-full border border-cyan-200/20 bg-cyan-300/10 px-2 py-[2px] text-[10px] font-semibold text-cyan-100">
                  Required
                </span>
              )}
 
              {n.leaveType && (
                <span className="text-[10px] text-white/60">
                  {n.leaveType}
                </span>
              )}
 




 <span className="text-[10px] text-white/70 ml-auto mb-[-14px] font-medium">
                {formatNotifTime(n.created_at)}
              </span>

              
            </div>
 
          </div>
 
</li>
      ))}
    </ul>
  )}
 
</div>
 
{!chatOpen && (
  <button
    onClick={() => {
      setChatTarget(null);
      setChatOpen(true);
    }}
    className="fixed bottom-6 right-6 z-[9000] grid h-14 w-14 place-items-center rounded-[22px] border border-cyan-200/25 bg-gradient-to-br from-cyan-400 via-violet-500 to-fuchsia-600 text-white shadow-[0_18px_45px_rgba(76,29,149,0.38)] ring-1 ring-white/15 transition hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(76,29,149,0.48)] sm:bottom-8 sm:right-8"
    aria-label="Open team chat"
    title="Open team chat"
  >
    <MessageCircle size={25} strokeWidth={2.35} />
    <span className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full border-2 border-[#12082f] bg-emerald-400 shadow-[0_0_14px_rgba(52,211,153,0.7)]" />
    {chatUnreadCount > 0 && (
      <span className="absolute -top-2 -right-2 flex h-6 min-w-[24px] items-center justify-center rounded-full border-2 border-[#12082f] bg-gradient-to-br from-red-400 to-rose-600 px-1 text-[10px] font-black leading-none text-white shadow-[0_8px_18px_rgba(244,63,94,0.42)]">
        {chatUnreadCount > 99 ? "99+" : chatUnreadCount}
      </span>
    )}
  </button>
)}

{chatOpen && <ChatDrawer initialChatTarget={chatTarget} onClose={() => setChatOpen(false)} />}
	{quickReplies.length > 0 && (
	  <div
	    className="fixed bottom-6 right-24 z-[9500] max-h-[calc(100vh-112px)] max-w-[calc(100vw-112px)] overflow-x-auto overflow-y-hidden rounded-[18px] p-1 sm:bottom-8 sm:right-28"
	    style={{ WebkitOverflowScrolling: "touch" }}
	  >
    <div className="flex flex-row-reverse items-end gap-2.5">
      {chunkQuickReplies(quickReplies, quickReplyRows).map((column, columnIndex) => (
      <div key={`quick-reply-column-${columnIndex}`} className="flex shrink-0 flex-col-reverse gap-2">
        {column.map((conversation, index) => (
          <QuickReplyPopup
            key={conversation.key}
            conversation={conversation}
            index={columnIndex * 3 + index}
            onClose={() =>
              setQuickReplies((current) =>
                current.filter((item) => item.key !== conversation.key)
              )
            }
            onReplySent={handleQuickReplySent}
          />
        ))}
      </div>
      ))}
    </div>
  </div>
)}
      {showMissingDocsPopup && (
        <div className="fixed inset-0 z-[9700] flex items-center justify-center bg-[#05020f]/70 px-4 py-6 backdrop-blur-sm">
          <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-white/12 bg-[#191429] text-white shadow-[0_28px_90px_rgba(0,0,0,0.55)]">
            <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-cyan-400 via-indigo-500 to-violet-500" />
            <button
              type="button"
              onClick={closeMissingDocsPopup}
              className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full border border-white/10 bg-white/[0.06] text-white/65 transition hover:bg-white/12 hover:text-white"
              aria-label="Close missing documents popup"
              title="Close"
            >
              <X size={18} />
            </button>

            <div className="p-6 pr-16">
              <div className="grid h-12 w-12 place-items-center rounded-2xl bg-amber-400/15 text-amber-200 ring-1 ring-amber-200/20">
                <FileText size={24} />
              </div>
              <h2 className="mt-4 text-xl font-black tracking-tight">Profile setup incomplete</h2>
              <p className="mt-2 text-sm leading-6 text-white/62">
                Please complete these required details to keep your Uptask profile ready for verification.
              </p>
            </div>

            <div className="border-y border-white/10 bg-white/[0.035] px-6 py-4">
              <p className="text-[10px] font-black uppercase tracking-[0.22em] text-cyan-200/70">
                Required details
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {missingProfileRequirements.map((item) => (
                  <span
                    key={item.type}
                    className="inline-flex items-center gap-2 rounded-full border border-amber-200/15 bg-amber-300/10 px-3 py-1.5 text-xs font-bold text-amber-100"
                  >
                    {item.type === "PROFILE_PHOTO" ? (
                      <User size={14} />
                    ) : item.type === "MOBILE_NUMBER" ? (
                      <Phone size={14} />
                    ) : (
                      <AlertCircle size={14} />
                    )}
                    {item.label}
                  </span>
                ))}
              </div>
              <div className="mt-4 space-y-2">
                {[...new Set(missingProfileRequirements.map((item) => item.path))].map((path) => (
                  <div key={path} className="rounded-xl border border-white/10 bg-black/15 px-3 py-2">
                    <p className="text-[11px] font-semibold text-white/55">Navigation path</p>
                    <p className="mt-0.5 text-sm font-bold text-white">{path}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-3 p-6 sm:flex-row sm:items-center sm:justify-end">
              <button
                type="button"
                onClick={closeMissingDocsPopup}
                className="rounded-xl border border-white/12 px-4 py-2.5 text-sm font-bold text-white/75 transition hover:bg-white/8 hover:text-white"
              >
                Remind me later
              </button>
              <button
                type="button"
                onClick={goToMissingProfileRoute}
                className="rounded-xl bg-gradient-to-r from-cyan-400 to-indigo-500 px-5 py-2.5 text-sm font-black text-white shadow-[0_14px_34px_rgba(59,130,246,0.28)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_42px_rgba(59,130,246,0.36)]"
              >
                {missingProfilePrimaryLabel}
              </button>
            </div>
          </div>
        </div>
      )}
      {showReportingPopup && !showMissingDocsPopup && (
        <div className="fixed inset-0 z-[9600] flex items-center justify-center bg-[#05020f]/65 px-4 py-6 backdrop-blur-sm">
          <div className="relative w-full max-w-lg overflow-hidden rounded-2xl border border-white/12 bg-[#171224] text-white shadow-[0_28px_90px_rgba(0,0,0,0.55)]">
            <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-cyan-400 via-violet-500 to-fuchsia-500" />
            <button
              type="button"
              onClick={closeReportingPopup}
              className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full border border-white/10 bg-white/[0.06] text-white/65 transition hover:bg-white/12 hover:text-white"
              aria-label="Close reporting summary"
              title="Close"
            >
              <X size={18} />
            </button>

            <div className="p-6 pr-16">
              <div className="grid h-12 w-12 place-items-center rounded-2xl bg-cyan-400/15 text-cyan-100 ring-1 ring-cyan-200/20">
                <Users size={24} />
              </div>
              <h2 className="mt-4 text-xl font-black tracking-tight">Your reporting line</h2>
              <p className="mt-2 text-sm leading-6 text-white/62">
                Here is the team structure assigned to you in Uptask.
              </p>
            </div>

            <div className="max-h-[52vh] space-y-4 overflow-y-auto border-y border-white/10 bg-white/[0.035] px-6 py-4">
              {reportingManagers.length > 0 && (
                <div>
                  <p className="text-[10px] font-black uppercase tracking-[0.22em] text-cyan-200/70">
                    Reporting manager
                  </p>
                  <div className="mt-3 grid gap-2">
                    {reportingManagers.map((person) => (
                      <div key={`manager-${person.id}`} className="flex items-center gap-3 rounded-2xl border border-white/10 bg-black/15 p-3">
                        <div className="h-11 w-11 overflow-hidden rounded-full bg-white/12 ring-1 ring-white/15">
                          {person.profile_pic ? (
                            <img src={getAvatarUrl(person.profile_pic)} alt={getPersonName(person)} className="h-full w-full object-cover" />
                          ) : (
                            <div className="grid h-full w-full place-items-center bg-violet-600 text-sm font-black">
                              {getPersonName(person).charAt(0)}
                            </div>
                          )}
                        </div>
                        <div className="min-w-0">
                          <p className="truncate text-sm font-black">{getPersonName(person)}</p>
                          <p className="truncate text-xs text-white/45">{person.job_title || person.email || "Manager"}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {reportingDirectors.length > 0 && (
                <div>
                  <p className="text-[10px] font-black uppercase tracking-[0.22em] text-violet-200/70">
                    Directors
                  </p>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {reportingDirectors.map((person) => (
                      <span key={`director-${person.id}`} className="inline-flex items-center gap-2 rounded-full border border-violet-200/15 bg-violet-300/10 px-3 py-1.5 text-xs font-bold text-violet-100">
                        <ShieldCheck size={14} />
                        {getPersonName(person)}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {reportingTeamMembers.length > 0 && (
                <div>
                  <p className="text-[10px] font-black uppercase tracking-[0.22em] text-emerald-200/70">
                    Team members
                  </p>
                  <div className="mt-3 grid gap-2 sm:grid-cols-2">
                    {reportingTeamMembers.map((person) => (
                      <div key={`member-${person.id}`} className="flex min-w-0 items-center gap-3 rounded-2xl border border-white/10 bg-black/15 p-3">
                        <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-white/12 ring-1 ring-white/15">
                          {person.profile_pic ? (
                            <img src={getAvatarUrl(person.profile_pic)} alt={getPersonName(person)} className="h-full w-full object-cover" />
                          ) : (
                            <div className="grid h-full w-full place-items-center bg-cyan-700 text-sm font-black">
                              {getPersonName(person).charAt(0)}
                            </div>
                          )}
                        </div>
                        <div className="min-w-0">
                          <p className="truncate text-sm font-black">{getPersonName(person)}</p>
                          <p className="truncate text-xs text-white/45">{person.job_title || person.email || "Team member"}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-end p-6">
              <button
                type="button"
                onClick={closeReportingPopup}
                className="rounded-xl bg-gradient-to-r from-cyan-400 to-indigo-500 px-5 py-2.5 text-sm font-black text-white shadow-[0_14px_34px_rgba(59,130,246,0.28)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_42px_rgba(59,130,246,0.36)]"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}
      <CreatePayrollInfoModal
        isOpen={isPayrollModalOpen}
        onClose={() => setIsPayrollModalOpen(false)}
        onSuccess={() => window.location.reload()}
      />
      
      {/* BACKDROP OVERLAY */}
{notifOpen && (
  <div
    className="
      fixed inset-0
      bg-black/50
      backdrop-blur-sm
      z-50
      transition-opacity
    "
    onClick={() => setNotifOpen(false)}
  />
)}
    </>
  );
}
 








































// import {
//   Home,
//   Users,
//   User,
//   BarChart2,
//   Settings,
//   Bell,
//   ChevronDown,
//   Menu,
//   X,
//   ClipboardList,
//   MessageCircle,
//   ChevronRight,
//   ShieldCheck,
//   ExternalLink,
// } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../app/store";
// import { useState,useEffect,useRef } from "react";
// import { Link } from "react-router-dom";
// import { useNotificationStore } from "../app/notificationStore";
// import userIcon from "../assets/user.png";
// import { LogOut } from "lucide-react";
// import { useLocation } from "react-router-dom";
// import ChatDrawer from "../pages/chat/ChatDrawer";
// import { getProfileApi, getChatUnreadApi } from "../app/api";  
// import CreatePayrollInfoModal from "../pages/payroll/components/CreatePayrollInfoModal";
// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
 
// export default function FilloNavbar() {
 
//   const location = useLocation();
//   const [profileOpen, setProfileOpen] = useState(false);
//   const profileRef = useRef(null);



//   const [theme, setTheme] = useState(
//     localStorage.getItem("theme") || "dark"
//   );
 
//   useEffect(() => {
//     document.documentElement.classList.toggle("dark", theme === "dark");
//     localStorage.setItem("theme", theme);
//   }, [theme]);
 
 
 
//   const [profilePic, setProfilePic] = useState(null);
//   const removeNotification = useNotificationStore(
//     (s) => s.removeNotification
//   );
 
 
//   const [notifOpen, setNotifOpen] = useState(false);
//   const notifRef = useRef(null);
//   const navigate = useNavigate();
//   const notifications = useNotificationStore((s) => s.notifications);
 
//   const unreadCount = useNotificationStore((s) => s.unreadCount);
//   const clearUnread = useNotificationStore((s) => s.clearUnread);
//   const chatUnreadCount = useNotificationStore((s) => s.chatUnreadCount);
//   const setChatUnreadCount = useNotificationStore((s) => s.setChatUnreadCount);
 
//   const [chatOpen, setChatOpen] = useState(false);
//   const [isPayrollModalOpen, setIsPayrollModalOpen] = useState(false);


//   useEffect(() => {
//     const chatData = localStorage.getItem("openChatFromNotification");
  
//     if (chatData) {
//       const parsed = JSON.parse(chatData);
  
//       // 🔥 open chat drawer
//       setChatOpen(true);
  
//       // 🔥 store selected user globally
//       window.__OPEN_CHAT_USER_ID__ = parsed.userId;
  
//       // clear storage
//       localStorage.removeItem("openChatFromNotification");
//     }
//   }, []);
 
//   const { logout } = useAuth();
//   const [open, setOpen] = useState(null);
//   const [mobileOpen, setMobileOpen] = useState(false);
 
 
// const user = JSON.parse(localStorage.getItem("user"));

// const hasExperience = Number(user?.experience) >= 2;
// const isHR = Number(user?.role_id) === 2;

// const canSeeAllProjects =
//   Number(user?.experience) >= 2 || isHR;
 
 
 
// const username = `${user.first_name || ""} ${user.last_name || ""}`.trim();
//   const menu = [
//     { label: "Dashboard", icon: Home, path: "/" },
 
 
//     ...(isHR
//       ? [
//           {
//             label: "Employees",
//             icon: Users,
//             children: [
//               { label: "Create User", path: "/employees/create" },
//               { label: "Employees", path: "/employees" },
//               { label: "Departments", path: "/departments" },
//               { label: "Ex Employees", path: "/employees/ex" },
//             ],
//           },
//         ]
//       : []),
 
//     {
//       label: "Attendance",
//       icon: BarChart2,
//       children: [
 
       
//         { label: "My Attendance", path: "/attendance/me" },
     
 
//          // only HR
//     ...(isHR
//       ? [
//           { label: "All Attendance", path: "/attendance/all" },
//           { label: "Monthly", path: "/attendance/monthly" },
//         ]
//       : []),
//       ],
//     },
 
//     /* ================= TASKS ================= */
//     {
//       label: "Tasks",
//       icon: ClipboardList,
//       children: [
//         { label: "Create Task", path: "/tasks/my" },
//         { label: "All Tasks", path: "/tasks/all" },
//         { label: "Team Tasks", path: "/tasks/team" },
//         { label: "Assigned Tasks", path: "/tasks/assigned" },
//         ...(isHR ? [{ label: "Monthly Tasks", path: "/tasks/monthly" }] : []),
//       ],
//     },
 
//     // ====================projects=====================


//     {
//       label: "Projects",
//       icon: ClipboardList,
//       children: [
//         { label: "Create Project", path: "/projects/create" },
    
//         ...(canSeeAllProjects
//           ? [{ label: "All Projects", path: "/projects/all" }]
//           : []),
    
//         { label: "My Projects", path: "/projects/my" },
//       ],
//     },



 
//     {
//       label: "Documents",
//       icon: ClipboardList,
//       children: [
//         { label: "Upload Documents", path: "upload/documents" },
     
 
//         ...(isHR
//           ? [
//             { label: "All Documents", path: "/documents/all" },
//             ]
//           : []),
//       ],
//     },


//     // {
//     //   label: "Gallery",
//     //   icon: ClipboardList,
//     //   children: [
//     //     { label: "View Gallery", path: "/gallery" },
     
 
        
//     //   ],
//     // },
 


//     {
//       label: "Gallery",
//       icon: ClipboardList,
//       path: "/gallery",
//     },

//     {
//       label: "Grievance",
//       icon: MessageCircle,
//       path: "/grievance",
//     },
//     // {
//     //   label: "Our Policy",
//     //   icon: ShieldCheck,
//     //   path: "/visiontrek/policy",
//     // },



//     {
//       label: "Policies",
//       icon: ShieldCheck,
//       children: [
//         // { label: "Leave Policy", path: "/leaves/policy" },
//         { 
//           label: "Leave Policy",
//           path: "/Leave policy (2026) 1.pdf",
//           external: true,
//           icon: ExternalLink
//         },
//         { 
//           label: "Increment Policy",
//           path: "/Increment.pdf",
//           external: true,
//           icon: ExternalLink
//         },
//       ],
//     },

 
//     ...(isHR
//       ? [
//         {
//           label: "Expenses",
//           icon: Settings,
//           children: [
//             { label: "Add Expense", path: "/expenses/add" },
//             { label: "Expense List", path: "/expenses" },
//             { label: "Wallet", path: "/expenses/wallet" },
//             { label: "Categories", path: "/expenses/categories" },
//           ],
//         },
   
//         ]
//       : []),
 
//     {
//       label: "Leaves",
//       icon: Settings,
//       children: [
//         { label: "Apply Leave", path: "/leaves/apply" },
//         { label: "My Leaves", path: "/leaves/me" },
       
 
//         ...(isHR
//           ? [
//             { label: "Pending", path: "/leaves/pending" },
//             { label: "Leave Report", path: "/leaves/report" },
//             ]
//           : []),
 
//         { label: "Leave Policy", path: "/leaves/policy" },
//         { label: "Holidays", path: "/leaves/holidays" },
//       ],
//     },
 
 
//     ...(isHR
//       ? [
//         {
//           label: "Inventory",
//           icon: Settings,
//           children: [
//             // { label: "Inventory Type", path: "/inventory" },
//             { label: "All Items", path: "/inventory/all" },
//             { label: "Assigned Items", path: "/inventory/assign" },
//             { label: "Add Item Type", path: "/inventory/add" },
           
//           ],
//         },
   
//         ]
//       : []),
//     ...(isHR
//       ? [
//         {
//           label: "Payroll",
//           icon: ClipboardList,
//           children: [
//             { label: "Payroll Overview", path: "/payroll" },
//             { label: "Monthly Records", path: "/payroll/records" },
//             { label: "Salary Details", path: "/payroll/salaries" },
//             { label: "Increment Section", path: "/payroll/increment" },
//             { label: "Create User Info", onClick: () => setIsPayrollModalOpen(true) },
//             { label: "Payslips", path: "/payroll/payslips" },
//           ],
//         },
//       ]
//       : []),
//     ];
 


//   // 👇 Pick what you want visible

//   const visibleLabels = ["Dashboard", "Attendance", "Tasks", "Projects", "Leaves", "Payroll"];

//   const desktopVisibleMenu = menu.filter((item) =>
//     visibleLabels.includes(item.label)
//   );

//   const desktopMoreMenu = menu.filter(
//     (item) => !visibleLabels.includes(item.label)
//   );


 
//   const desktopMenu = [
//     ...desktopVisibleMenu,
//     ...(desktopMoreMenu.length > 0
//       ? [
      

//           {
//             label: "More",
//             isMore: true,
//             children: desktopMoreMenu,
//           }
//         ]
//       : []),
//   ];
 
 
 
//   const scrollToContent = () => {
//     setMobileOpen(false);
//     setTimeout(() => {
//       const el = document.getElementById("page-content");
//       if (el) {
//         el.scrollIntoView({ behavior: "smooth", block: "start" });
//       }
//     }, 150);
//   };
 
 
 
//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (notifRef.current && !notifRef.current.contains(e.target)) {
//         setNotifOpen(false);
//       }
//     }
 
//     if (notifOpen) {
//       document.addEventListener("click", handleClickOutside);
//     }
 
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [notifOpen]);
 
 
 
 
 
//   useEffect(() => {
//     const loadProfile = async () => {
//       const res = await getProfileApi();
//       if (res?.success) {
//         setProfilePic(res.data.profile_pic);
//       }
//     };
   
//     const loadUnreadChats = async () => {
//       try {
//         const res = await getChatUnreadApi();
//         if (res?.success) setChatUnreadCount(res.count);
//       } catch(e){}
//     };
 
//     loadProfile();
//     loadUnreadChats();
//   }, []);
 




//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (profileRef.current && !profileRef.current.contains(e.target)) {
//         setProfileOpen(false);
//       }
//     }
  
//     document.addEventListener("click", handleClickOutside);
//     return () => document.removeEventListener("click", handleClickOutside);
//   }, []);





//   const formatNotifTime = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     return d.toLocaleString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric", // optional but better
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const getRelativeNotifTime = (date) => {
//     if (!date) return "";
//     const now = new Date();
//     const d = new Date(date);
//     const diffInSeconds = Math.floor((now - d) / 1000);

//     if (diffInSeconds < 60) return "Now";
//     if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    
//     if (now.toDateString() === d.toDateString()) return "Today";
    
//     const diffInDays = Math.floor(diffInSeconds / 86400);
//     if (diffInDays === 1) return "1 day ago";
//     return `${diffInDays} days ago`;
//   };





 
//   return (
//     <>
//       {/* ================= TOP NAVBAR ================= */}
//       <div
//         className="
//         h-16 px-4 sm:px-6 flex items-center justify-between
//         bg-[#291857]
//         shadow-lg shadow-black/40
//         backdrop-blur-xl
//         border-b border-white/10
//         text-white
//         relative z-50
//       "
//       >
//         {/* LEFT */}
//         <div className="flex items-center gap-4">
//           <button className="lg:hidden" onClick={() => setMobileOpen(true)}>
//             <Menu size={22} />
//           </button>
 
       
//         </div>
 
//         {/* CENTER (DESKTOP MENU) */}
//         <div className="hidden lg:flex gap-6 text-[13px] relative font-bold">
//           {desktopMenu.map((item, i) => {
//             const Icon = item.icon;
//             const isActive = item.path
//             ? location.pathname === item.path
//             : item.children?.some((sub) =>
//                 location.pathname.startsWith(sub.path)
//               );
//             return (
//               <div
//                 key={i}
//                 className="relative"
//                 onMouseEnter={() => setOpen(i)}
//                 onMouseLeave={() => setOpen(null)}
//               >
          

// {/* <div className="flex items-center gap-0.5 cursor-pointer hover:text-purple-200 py-1"> */}




// <div
//   className={`
//     flex items-center gap-1 cursor-pointer py-1 px-2 rounded-md transition
//     ${isActive ? "bg-white/20 text-white" : "hover:bg-white/10"}
//   `}
// >
//   {/* {item.path ? (
//     <Link to={item.path} className="flex items-center gap-2">
//       {item.icon && <Icon size={14} />}
//       {item.label}
//     </Link>
//   ) : ( */}

// {item.path ? (
//   item.external ? (
//     <a
//       href={item.path}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="flex items-center gap-2"
//     >
//       {item.icon && <Icon size={14} />}
//       {item.label}
//     </a>
//   ) : (
//     <Link to={item.path} className="flex items-center gap-2">
//       {item.icon && <Icon size={14} />}
//       {item.label}
//     </Link>
//   )
// ) : (
//     <>
//       {item.icon && <Icon size={14} />}
//       {item.label}
//       <ChevronDown size={14} />
//     </>
//   )}
// </div>
 
//                 {item.children && open === i && (
//                   <div
//                     className={`
//                     absolute left-0 top-[100%] z-50
//                     bg-[#3a2a72]/95
//                     backdrop-blur-sm
//                     border border-white/10
//                     rounded-xl shadow-lg
//                     py-2 whitespace-nowrap
//                     `}
//                     style={{ minWidth: item.isMore ? '180px' : '144px' }}
//                   >
//                     <div className="absolute -top-2 left-0 w-full h-2" />
//                     {item.isMore ? (
//                         item.children.map((moreItem, idx) => {
//                             const MoreIcon = moreItem.icon;
//                             const content = (
//                                 <div className="flex items-center gap-2 w-full">
//                                     {MoreIcon && <MoreIcon size={14} />}
//                                     {moreItem.label}
//                                     {moreItem.children && <ChevronRight size={14} className="ml-auto" />}
//                                 </div>
//                             );
//                             return (
//                                 <div
//                                     key={idx}
//                                     className="relative group px-4 py-2 hover:bg-[#4b3a8a] cursor-pointer"
//                                 >
//                                     {moreItem.path ? (
//                                         moreItem.external ? (
//                                             <a 
//                                                 href={moreItem.path} 
//                                                 target="_blank" 
//                                                 rel="noopener noreferrer" 
//                                                 className="block w-full"
//                                             >
//                                                 {content}
//                                             </a>
//                                         ) : (
//                                             <Link to={moreItem.path} className="block w-full">{content}</Link>
//                                         )
//                                     ) : (
//                                         <div className="block w-full">{content}</div>
//                                     )}
 
//                                     {moreItem.children && (
//                                         <div className="absolute left-[99%] top-0 hidden group-hover:block bg-[#3a2a72]/95 backdrop-blur-md border border-white/10 rounded-xl shadow-lg py-2 min-w-[144px]">
//                                             <div className="absolute -left-2 top-0 w-2 h-full" />
//                                             {moreItem.children.map((sub, j) => {
//                                                 const SubIcon = sub.icon;
//                                                 const subContent = (
//                                                     <div className="flex items-center gap-2">
//                                                         {SubIcon && <SubIcon size={14} />}
//                                                         {sub.label}
//                                                     </div>
//                                                 );
//                                                 return sub.external ? (
//                                                     <a
//                                                         key={j}
//                                                         href={sub.path}
//                                                         target="_blank"
//                                                         rel="noopener noreferrer"
//                                                         className="block px-4 py-2 hover:bg-[#4b3a8a]"
//                                                     >
//                                                         {subContent}
//                                                     </a>
//                                                 ) : (
//                                                     <Link
//                                                         key={j}
//                                                         to={sub.path}
//                                                         className="block px-4 py-2 hover:bg-[#4b3a8a]"
//                                                     >
//                                                         {subContent}
//                                                     </Link>
//                                                 )
//                                             })}


// </div>
//                                     )}
//                                 </div>
//                             );
//                         })
//                     ) : (
// //                         item.children.map((sub, j) => (
                          
// //                             <Link
// //   key={j}
// //   to={sub.path}
// //   className={`
// //     block px-4 py-2
// //     ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
// //   `}
// // >
// //                                 {sub.label}
// //                             </Link>
// //                         ))





// item.children.map((sub, j) => {
//   const SubIcon = sub.icon;
//   const subContent = (
//     <div className="flex items-center gap-2">
//       {SubIcon && <SubIcon size={14} />}
//       {sub.label}
//     </div>
//   );
//   return (
//     <div key={j}>
//       {sub.onClick ? (
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             setOpen(null);
//             sub.onClick();
//           }}
//           className="w-full text-left block px-4 py-2 hover:bg-[#4b3a8a] transition"
//         >
//           {subContent}
//         </button>
//       ) : sub.external ? (
//         <a
//           href={sub.path}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="block px-4 py-2 hover:bg-[#4b3a8a]"
//         >
//           {subContent}
//         </a>
//       ) : (
//         <Link
//           to={sub.path}
//           className={`
//             block px-4 py-2
//             ${location.pathname === sub.path ? "bg-[#4b3a8a]" : "hover:bg-[#4b3a8a]"}
//           `}
//         >
//           {subContent}
//         </Link>
//       )}
//     </div>
//   )
// })
//                     )}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
 
//         {/* RIGHT */}
//         <div className="flex items-center gap-4 text-sm ">
// <div className="relative mt-2 gap-6">
//   <button
//       onClick={() => setChatOpen(true)}
//       className=" mr-2 rounded-full hover:bg-white/10 transition text-white relative"
//     >
//       <MessageCircle size={20} />
//       {chatUnreadCount > 0 && (
//         <span className="
//         absolute -top-2 -right-2
//         bg-red-500 text-white
//         text-[10px] font-bold
//         w-5 h-5 rounded-full
//         flex items-center justify-center
//          ">
//           {chatUnreadCount}
//         </span>
//       )}
//   </button>
 
//   <button
//       onClick={(e) => {  
//       e.stopPropagation();        // 🔥 THIS LINE FIXES IT
//       setNotifOpen((o) => !o);
//       clearUnread();
//     }}
//     className="relative"
//   >
 
//   <Bell
//   size={20}
//   className={unreadCount > 0 ? "animate-bell" : ""}
// />
 
//     {unreadCount > 0 && (
//       <span
//         className="
//           absolute -top-2 -right-2
//           bg-red-500 text-white
//           text-[10px] font-bold
//           w-5 h-5 rounded-full
//           flex items-center justify-center
//         "
//       >
//         {unreadCount}
//       </span>
//     )}
//   </button>
 
 
// </div>


//  <div className="relative w-7 h-7 " ref={profileRef}>
//   <button
//     onClick={(e) => {
//       e.stopPropagation();
//       setProfileOpen((prev) => !prev);
//     }}
//     className="w-8 h-8 rounded-full overflow-hidden bg-white/20"
//   >
//     {profilePic ? (
//       <img
//         src={`${IMAGE_BASE_URL}${profilePic}`}
//         className="w-8 h-8 object-cover "
//         alt="Profile"
//         />
//     ) : (
//       <User size={14} className=" ml-2" />
//     )}
//   </button>

//   {profileOpen && (
      
// <div className="absolute right-0 mt-2 w-34 bg-[#3a2a72] border border-white/10 rounded-lg shadow-lg z-50">

// <Link
//   to="/profile"
//   onClick={() => setProfileOpen(false)}
//   className="flex items-center gap-2 px-4 py-2 hover:bg-[#4b3a8a] text-white"
// >
//   <User size={16} className="text-white" />
//   Profile
// </Link>

// <button
//   onClick={() => {
//     setProfileOpen(false);
//     logout();
//   }}
//   className="w-full flex items-center gap-2 px-4 py-2 text-left hover:bg-red-500/30 text-white"
// >
//   <LogOut size={16} className="text-white" />
//   Logout
// </button>

// </div>


//   )}
// </div>

//         </div>
//       </div>
 
//       {/* ================= MOBILE SIDEBAR ================= */}
//       {mobileOpen && (
//         <div className="fixed inset-0 z-50 lg:hidden">
//           <div
//             className="absolute inset-0 bg-black/50"
//             onClick={() => setMobileOpen(false)}
//           />
 
//           <div
//             className="
//             absolute left-0 top-0 h-full w-72
//             bg-[#291857]
//             shadow-2xl shadow-black/50
//             p-5
//             flex flex-col gap-4
//             text-white
//             overflow-y-auto
//           "
//           >
//             <div className="flex justify-between items-center mb-4">
//               <span className="font-semibold text-lg">UPTASK</span>
//               <button onClick={() => setMobileOpen(false)}>
//                 <X size={22} />
//               </button>
//             </div>
 
//             {menu.map((item, i) => {
//               const Icon = item.icon;
 
//               return (
//                 <div key={i}>
//                   {item.path ? (
//                     item.external ? (
//                       <a
//                         href={item.path}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={() => setMobileOpen(false)}
//                         className="flex items-center gap-3 py-2"
//                       >
//                         <Icon size={18} />
//                         {item.label}
//                       </a>
//                     ) : (
//                       <Link
//                         to={item.path}
//                         onClick={() => setMobileOpen(false)}
//                         className="flex items-center gap-3 py-2"
//                       >
//                         <Icon size={18} />
//                         {item.label}
//                       </Link>
//                     )
//                   ) : (
//                     <>
//                       <div className="flex items-center gap-3 py-2 opacity-80">
//                         <Icon size={18} />
//                         {item.label}
//                       </div>
 
//                       <div className="ml-7 flex flex-col text-sm opacity-70">
//                         {item.children.map((sub, j) => {
//                           const SubIcon = sub.icon;
//                           const subContent = (
//                             <div className="flex items-center gap-3">
//                               {SubIcon && <SubIcon size={18} />}
//                               {sub.label}
//                             </div>
//                           );
//                           if (sub.onClick) {
//                             return (
//                               <button
//                                 key={j}
//                                 onClick={() => {
//                                   setMobileOpen(false);
//                                   sub.onClick();
//                                 }}
//                                 className="py-1 text-left w-full"
//                               >
//                                 {subContent}
//                               </button>
//                             );
//                           }

//                           return sub.external ? (
//                             <a
//                               key={j}
//                               href={sub.path}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               onClick={() => setMobileOpen(false)}
//                               className="py-1"
//                             >
//                               {subContent}
//                             </a>
//                           ) : (
//                             <Link
//                               key={j}
//                               to={sub.path}
//                               onClick={scrollToContent}
//                               className="py-1"
//                             >
//                               {subContent}
//                             </Link>
//                           )
//                         })}
//                       </div>
//                     </>
//                   )}
//                 </div>
//               );
//             })}
 

 
//             <div className="mt-auto pt-4 border-t border-white/10">
 
 
 
//               <button
//                 onClick={logout}
//                 className="w-full bg-red-500 py-2 rounded"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
 
 
 
 
 
 
 
 
 
 
 
//       {/* ================= NOTIFICATION DRAWER ================= */}
// {/* ================= NOTIFICATION DRAWER ================= */}
 
// <div
//   className={`
//   fixed top-0 right-0 h-full w-[400px] max-w-[95vw]
//   bg-[#2A1D55]/95
//   supports-[backdrop-filter]:bg-white/10
//   backdrop-blur-xl
//   border-l border-white/20
//   shadow-[0_20px_60px_rgba(0,0,0,0.4)]
//   z-[60]
//   transform transition-all duration-500 ease-outout
//     ${notifOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}
//   `}
// >
 
//   {/* HEADER */}
//   <div className="flex justify-between items-center px-5 py-4 border-b border-white/20 backdrop-blur-md bg-[#2A1D55]">
 
//     <span className="text-lg font-semibold text-white tracking-wide ">
//       Notifications
//     </span>
 
//     <button
//       onClick={() => setNotifOpen(false)}
//       className="p-1 rounded-lg text-white/70 hover:text-red-400 hover:bg-white/10 transition"
//     >
//       <X size={20} />
//     </button>
 
//   </div>
 
 
//   {/* CLEAR ALL */}
//   {notifications.length > 0 && (
//     <div className="flex justify-end px-5 mt-2 ">
//       <button
//         onClick={() => useNotificationStore.getState().clearAll()}
//         className="
//           text-xs font-semibold
//           text-red-500 hover:text-red-400
//           transition
//         "
//       >
//         Clear All
//       </button>
//     </div>
//   )}
 
 
//   {/* BODY */}
//   {notifications.length === 0 ? (
//     <div className="flex items-center justify-center h-[70%] text-white/70 text-sm">
//       No notifications
//     </div>
//   ) : (
//     <ul className="overflow-y-auto h-[calc(100%-120px)] p-4 space-y-3">
 
//       {notifications.map((n) => (

      

// //         <li
// //         key={n.id}
// //         className="
// //           relative flex gap-3 p-3
// //           bg-white/10 backdrop-blur-md
// //           border border-white/10
// //           rounded-xl
// //           hover:bg-white/20
// //           transition-all duration-200
// //           shadow-md
// //           group
// //         "
// // >

//         <li
//         key={n.id}
//         className="
//     relative flex gap-3 p-3 bg-[#1e1e2f]/80
//         border border-white/10 rounded-xl hover:bg-[#2a2a40]
//        transition-all duration-200 shadow-md group backdrop-blur-sm
//         "
// >

//         {/* CLOSE BUTTON */}
// <button
//           onClick={(e) => {
//             e.stopPropagation();
//             removeNotification(n.id);
//           }}
//           className="
//             absolute top-2 right-2
//             opacity-0 group-hover:opacity-100
//             transition
//             text-white hover:text-red-400
//           "
// >
// <X size={14} />
// </button>

//         {/* AVATAR */}
// <div className="w-9 h-9 rounded-full overflow-hidden bg-white/20 border border-white/20 shrink-0">


//   <img
//     src={
//       n.sender_profile_pic
//         ? `${IMAGE_BASE_URL}${n.sender_profile_pic}`
//         : n.userdata?.profile_pic
//         ? `${IMAGE_BASE_URL}${n.userdata.profile_pic}`
//         : userIcon
//     }
//     className="w-9 h-9 object-cover"
//     alt="User"
//     onError={(e) => (e.target.src = userIcon)}
//   />
// </div>

// {/* RELATIVE TIME IN TOP RIGHT */}
// <div className="absolute top-1 right-3 text-[8px] font-bold text-white/50 uppercase tracking-wider group-hover:opacity-0 transition-opacity">
//   {getRelativeNotifTime(n.created_at)}
// </div>
// <div
//           className="flex-1 cursor-pointer"
       




//           onClick={() => {
//             removeNotification(n.id);
//             setNotifOpen(false);
          
//             const typeKey = (n.type || "").toUpperCase();
          
//             if (typeKey === "LEAVE") {
//               navigate("/leaves/pending");
          
//             } else if (typeKey === "CHAT") {
//               setChatOpen(true);

//             } else if (typeKey === "LATE PUNCH IN") {
//                 navigate("/attendance/all");

//               } else if (typeKey === "EXTRA BREAK") {
//                 navigate("/attendance/all");
//               } else if (typeKey === "EARLY PUNCH OUT") {
//                 navigate("/attendance/all");


//               } else if (typeKey === "TASK ASSIGNED") {
//                 navigate("/tasks/assigned");
                
//               } else if (typeKey === "GRIEVANCE_UPDATE") {
//                 navigate("/grievance");



//               } else if (typeKey === "TASK COMMENT") {
//                 navigate("/tasks/all");
//               } else if (typeKey === "TASK UPDATED") {
//                 navigate("/tasks/all");
//               } else if (typeKey === "TASK DUE TODAY") {
//                 navigate("/tasks/all");
//               } else if (typeKey === "DUE DATE CHANGED") {
//                 navigate("/tasks/all");






          
//             } else if (
//               typeKey.includes("POST") || 
//               typeKey.includes("FEED")
//             ) {
//               navigate("/", { state: { tab: "posts" } });
          
//             } else {
//               // ✅ MAIN FIX (your requirement)
//               navigate(n.redirectTo || "/");
//             }
//           }}
// >


// <div className="text-sm font-medium text-white leading-snug">
//               {n.message}
//             </div>
 
//             <div className="flex items-center gap-2 mt-1">
 
//               <span className="
//                 text-[10px]
//                 px-2 py-[2px]
//                 rounded-sm shadow-lg
//                 bg-purple-500/30
//                 text-purple-200
//                 font-semibold
//               ">
//                 {n.type.toUpperCase()}
//               </span>
 
//               {n.leaveType && (
//                 <span className="text-[10px] text-white/60">
//                   {n.leaveType}
//                 </span>
//               )}
 




//  <span className="text-[10px] text-white/70 ml-auto mb-[-14px] font-medium">
//                 {formatNotifTime(n.created_at)}
//               </span>

              
//             </div>
 
//           </div>
 
// </li>
//       ))}
//     </ul>
//   )}
 
// </div>
 
// {chatOpen && <ChatDrawer onClose={() => setChatOpen(false)} />}
//       <CreatePayrollInfoModal 
//         isOpen={isPayrollModalOpen} 
//         onClose={() => setIsPayrollModalOpen(false)} 
//         onSuccess={() => window.location.reload()}
//       />
      
//       {/* BACKDROP OVERLAY */}
// {notifOpen && (
//   <div
//     className="
//       fixed inset-0
//       bg-black/50
//       backdrop-blur-sm
//       z-50
//       transition-opacity
//     "
//     onClick={() => setNotifOpen(false)}
//   />
// )}
//     </>
//   );
// }
 








